import { Component, Input } from '@angular/core';

@Component({
  selector: 'ubc-no-customer-message',
  standalone: true,
  imports: [],
  templateUrl: './no-customer-message.component.html',
  styleUrl: './no-customer-message.component.scss'
})
export class NoCustomerMessageComponent {

  @Input() target: string = ""

}
